import React, { useState, useRef } from 'react';
import { Card, Grid, Box, Container } from '@material-ui/core';
import InfoScraperNew from 'src/views/harvesting/Info-scraper/info-scraper';
import FishInputBox from 'src/views/harvesting/fruit-profile/fruit-input-box';
import { FruitProfilDndParents } from 'src/views/harvesting/fruit-profile/fruit-profile-dnd-parents';
import ShareIsLoveDialog from 'src/components/Dialog/ShareIsLoveDialog';
import Page from 'src/components/Page';
import FishStatusTabs from 'src/views/harvesting/fruit-status-tabs';
import { useHarvestingContext } from 'src/views/harvesting/harvesting-context';
import { useAlertContext } from 'src/context/AlertContext';
import { SettingBar } from 'src/views/harvesting/setting-bar';
import LoadingProfile from 'src/views/harvesting/fruit-profile/fruit-profile-loading';
import { FruitPropsType } from 'src/views/harvesting/fruit-profile/model';
import {usePreferenceContext} from 'src/context/PreferenceContext';
import {GroupRequiredDialog} from 'src/views/harvesting/group-required-dialog';
import {ReportDailyResults} from 'src/views/harvesting/report-daily-results';
function App() {
  const fishlistRef = useRef(null);

  const { useErrorAlert } = useAlertContext();
  const [loading, setLoading] = useState(false);

  const [submitPopUp, setSubmitPopUp] = useState(false);

  const platform = 'Facebook';
  const [shareIsLove, setShareIsLove] = useState(false);

  const { addFruits, resetBaskets } = useHarvestingContext();

  const {setFruitsTab}= usePreferenceContext(); //no

  const pasteValueExtract = (e:any) => {
    setLoading(true);
    setFruitsTab('Available');
    const htmlText = e.clipboardData.getData('text/html');
    const plainText = e.clipboardData.getData('text/plain');
    InfoScraperNew(htmlText,plainText, platform)
      .then((results) => {
        addFruits(results as FruitPropsType[]);
        setLoading(false);
      })
      .catch((error) => {
        useErrorAlert('Bad format, please copy the data again from your source and paste here again',error);
        resetBaskets();
        setLoading(false);
      });
  };

  return (
    <Page title="Fishing">
      <Container>
        <Box display="flex" flexDirection="column" gridGap={16} mt={2}>
          <Card>
            <Box p={2}>
              <FishInputBox
                fishlistRef={fishlistRef}
                onPaste={(e:any) => pasteValueExtract(e)}
                variant="outlined"
                placeholder="Please paste Social Media data here"
                label="Social Media/ Fishes"
              />
            </Box>
          </Card>

          <SettingBar
            setShareIsLove={setShareIsLove}
          />

          <Grid container component="main" spacing={2}>
            <Grid item xs={12} sm={12} md={9}>
              <FishStatusTabs />
              {!loading ? (
                <FruitProfilDndParents
                  //TODO: CHECK THIS OUT
                  // innerRef={fishlistRef}
                  // lightBoxOption={true}
                  // size={'small'}
                  // loading={loading}
                />
              ) : (
                <LoadingProfile />
              )}
            </Grid>
            <Grid item xs={12} sm={12} md={3}>
              <ReportDailyResults/>
            </Grid>
          </Grid>
        </Box>
      </Container>

      <ShareIsLoveDialog open={shareIsLove} setOpen={setShareIsLove} />
      <GroupRequiredDialog/>
    </Page>
  );
}

export default App;
